<script setup lang="ts">
import { OzDropdownButtonColorScheme } from '@@/library/v4/components/OzDropdownButton.vue'
import OzIconButton, { OzIconButtonColorScheme } from '@@/library/v4/components/OzIconButton.vue'
import LocaleSelector from '@@/vuecomponents/LocaleSelector.vue'
import { __ } from '@@/bits/intl'
</script>

<template>
  <nav :aria-label="__('Bottom bar')" class="flex items-center">
    <OzIconButton
      class="me-1"
      :color-scheme="OzIconButtonColorScheme.SecondaryClear"
      icon-name="help"
      :icon-size="24"
      :label="__('Help page')"
      href="https://padlet.help"
      target="_blank"
    />
    <OzIconButton
      class="me-2"
      :color-scheme="OzIconButtonColorScheme.SecondaryClear"
      icon-name="accessibility_outline"
      :icon-size="24"
      :label="__('Accessibility')"
      href="https://padlet.com/about/accessibility"
      target="_blank"
    />
    <LocaleSelector :button-color-scheme="OzDropdownButtonColorScheme.SecondaryClear" />
  </nav>
</template>
